module.exports = __webpack_public_path__ + "static/media/DEENCONNECT_MasjidBaitusSalam_CarpetInstallation.ebb20c39.jpg";